import { gql } from '@apollo/client'

export const PREVIEW_PLAN_CHANGE_INVOICE = gql`
  query PreviewPlanChangeInvoice($input: UpdateSubscriptionPlanInput!) {
    previewPlanChangeInvoice(input: $input) {
      subtotal
      totalTaxes
      total
      amountDue
      currency
      lines {
        amount
        description
        currency
      }
    }
  }
`
